import en from './locale/en';
import pt_BR from './locale/pt_BR';

export default {
  en,
  pt_BR,
};
